import PropTypes from "prop-types";
import QuoteCard from "../QuoteCard/QuoteCard";
import styles from "./QuotesList.module.css";

const QuotesList = ({
  quotes,
  onKeyTariffFacts,
  formData,
  singleRateBilling,
}) => {
  if (!quotes || quotes.length === 0) {
    return (
      <div className={styles.noQuotes} aria-live="polite">
        <p>No quotes available for the selected filter.</p>
      </div>
    );
  }

  return (
    <div
      id="quotes-list"
      className={styles.quotesList}
      aria-label="Available quotes"
    >
      {quotes?.map((quote, index) => (
        <QuoteCard
              key={`${index + 1}`}
          quote={quote}
          onKeyTariffFacts={onKeyTariffFacts}
          formData={formData}
          singleRateBilling={singleRateBilling}
        />
      ))}
    </div>
  );
};

QuotesList.propTypes = {
  quotes: PropTypes.array,
  onKeyTariffFacts: PropTypes.func.isRequired,
  formData: PropTypes.object,
  singleRateBilling: PropTypes.bool,
};

export default QuotesList;
